module.exports = __webpack_public_path__ + "img/26_186.74201388.png";